import { useDragLayer, XYCoord } from "react-dnd";

function getDragLayerStyles(
  initialOffset: XYCoord | null,
  currentOffset: XYCoord | null
) {
  if (!initialOffset || !currentOffset) {
    return {
      display: "none",
    };
  }

  let { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

interface TestDragLayerProps {
  overrideSrc: string | undefined;
}

export default function CustomDragLayer(props: TestDragLayerProps) {
  const {
    itemType,
    isDragging,
    item,
    initialOffset,
    currentOffset,
  } = useDragLayer((monitor: any) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  const renderItem = () => {
    return (
      <div className="dragitem" style={{ pointerEvents: "none" }}>
        {props.overrideSrc && (
          <img
            src={props.overrideSrc}
            crossOrigin="anonymous"
            style={{ pointerEvents: "none", zIndex: Number.MAX_SAFE_INTEGER, verticalAlign: "top", height: "30px"}}
          />
        )}

        <img
          src={item.src}
          crossOrigin="anonymous"
          style={{ pointerEvents: "none", zIndex: Number.MAX_SAFE_INTEGER, height: 60 }}
        />
      </div>
    );
  };

  if (!isDragging) {
    return null;
  }

  return (
    <div
      className="draglayer"
      style={{ top: 0, left: 0, position: "fixed", pointerEvents: "none", zIndex: Number.MAX_SAFE_INTEGER }}
    >
      <div style={getDragLayerStyles(initialOffset, currentOffset)}>
        {renderItem()}
      </div>
    </div>
  );
}
